import { ConfigurationSchema } from '@jbrowse/core/configuration';
import { createBaseTrackConfig } from '@jbrowse/core/pluggableElementTypes/models';
/**
 * #config MultiQuantitativeTrack
 */
function x() { } // eslint-disable-line @typescript-eslint/no-unused-vars
const configSchema = (pluginManager) => {
    return ConfigurationSchema('MultiQuantitativeTrack', {}, {
        /**
         * #baseConfiguration
         */
        baseConfiguration: createBaseTrackConfig(pluginManager),
    });
};
export default configSchema;
